const initialState = {
  showWelcome: true,
};

export default function auth(state=initialState, action) {

  switch (action.type) {

    case 'SHOW_WELCOME':
      return {showWelcome: true};

    case 'HIDE_WELCOME':
      return {showWelcome: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ux.js